<template lang="pug">
.local-plugin-signature-flow
  qualified-signature-load-plugin-modal(
    ref='qualifiedSignatureLoadPluginModal'
  )
  qualified-signature-loading-modal(ref='qualifiedSignatureLoadingModal')
  qualified-signature-download-plugin-modal(
    @close='init'
    ref='qualifiedSignatureDownloadPluginModal'
  )
  qualified-signature-execute-plugin-modal(
    @close='tryAgain'
    ref='qualifiedSignatureExecutePluginModal'
  )
  qualified-signature-not-found-plugin-modal(
    @back-to-download-plugin='openDownloadPluginModal'
    @closed='tryAgain'
    ref='qualifiedSignatureNotFoundPluginModal'
  )
  qualified-signature-plugin-authorize-modal(
    :show-proceed-button='canProceed'
    @closed='authorizeModalClosed'
    @proceed='onProceed'
    ref='qualifiedSignaturePluginAuthorizeModal'
  )
  qualified-signature-list-certificates-plugin-modal(
    :certificates='certificates'
    :user-email='envelope.value'
    @certificate-selected='onSelectCertificate'
    ref='qualifiedSignatureListCertificatesPluginModal'
  )
  qualified-signature-pin-plugin-modal(
    :certificate='cert'
    :error-msg='pinErrorMsg'
    :user-email='envelope.value'
    @clear-error='pinErrorMsg = ""'
    @confirmed='pinModalConfirmed'
    ref='qualifiedSignaturePinPluginModal'
  )
</template>
<script>
import LocalStorage from '@/services/LocalStorage';
import SignPluginService from '@/modules/business/services/http/SignPlugin/SignPluginService';
// eslint-disable-next-line max-len
import QualifiedSignatureLoadPluginModal from '@/modules/business/components/organisms/modals/QualifiedSignatureLoadPluginModal.vue';
// eslint-disable-next-line max-len
import QualifiedSignatureLoadingModal from '@/modules/business/components/organisms/modals/QualifiedSignatureLoadingModal.vue';
// eslint-disable-next-line max-len
import QualifiedSignatureDownloadPluginModal from '@/modules/business/components/organisms/modals/QualifiedSignatureDownloadPluginModal.vue';
// eslint-disable-next-line max-len
import QualifiedSignatureListCertificatesPluginModal from '@/modules/business/components/organisms/modals/QualifiedSignatureListCertificatesPluginModal.vue';

// eslint-disable-next-line max-len
import QualifiedSignaturePluginAuthorizeModal from '@/modules/business/components/organisms/modals/QualifiedSignaturePluginAuthorizeModal.vue';

import EnvelopesPublicService from '@/modules/business/services/http/envelopes/EnvelopesPublicService';
import QualifiedSignaturePinPluginModal from '@/modules/business/components/organisms/modals/QualifiedSignaturePinPluginModal.vue';
import QualifiedSignatureExecutePluginModal from '@/modules/business/components/organisms/modals/QualifiedSignatureExecutePluginModal.vue';
import QualifiedSignatureNotFoundPluginModal from '@/modules/business/components/organisms/modals/QualifiedSignatureNotFoundPluginModal.vue';
import Logger from '@/services/Logger';
import alert from '@/modules/account/common/alert';

export default {
  name: 'LocalPluginSignatureFlow',
  components: {
    QualifiedSignatureLoadPluginModal,
    QualifiedSignatureLoadingModal,
    QualifiedSignatureDownloadPluginModal,
    QualifiedSignatureListCertificatesPluginModal,
    QualifiedSignaturePluginAuthorizeModal,
    QualifiedSignaturePinPluginModal,
    QualifiedSignatureExecutePluginModal,
    QualifiedSignatureNotFoundPluginModal,
  },
  props: {
    envelope: {
      type: Object,
    },
    location: {
      type: Object,
    },
  },
  data() {
    return {
      nonce: '',
      challenge: '',
      app: '',
      token: '',
      certificates: [],
      license: '',
      documents: [],
      canProceed: false,
      loginPollingInterval: null,
      cert: null,
      pin: '',
      pluginCheckFailedOnce: false,
      pinErrorMsg: '',
    };
  },
  created() {
    this.app = LocalStorage.get('signg-plugin-app-data');
  },
  methods: {
    openDownloadPluginModal() {
      this.$refs.qualifiedSignatureDownloadPluginModal.$refs.modal.open();
    },
    async init() {
      this.$refs.qualifiedSignatureLoadingModal.text = this.$t(
        'modal.qualifiedSignatureCertificatePluginModal.loading.verifyPluginMessage'
      );
      this.$refs.qualifiedSignatureLoadingModal.$refs.modal.open();
      try {
        await this.hello();
      } catch (error) {
        this.$refs.qualifiedSignatureDownloadPluginModal.$refs.modal.close();
        if (this.pluginCheckFailedOnce) {
          this.$refs.qualifiedSignatureExecutePluginModal.$refs.modal.open();
          return;
        }
        this.pluginCheckFailedOnce = true;
        this.openDownloadPluginModal();
        return;
      } finally {
        setTimeout(() => {
          this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
        }, 2500);
      }

      await this.continue();
    },
    async hello() {
      const res = await SignPluginService.hello();
      this.nonce = res.data.Nonce;
      this.challenge = res.data.Challenge;
    },
    async tryAgain() {
      try {
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.open();
        await this.hello();
        await this.continue();
      } catch (error) {
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
        this.$refs.qualifiedSignatureNotFoundPluginModal.$refs.modal.open();
        Logger.consoleError('Not found plugin', error);
      } finally {
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
      }
    },
    async continue() {
      if (!this.challenge || !this.nonce) {
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
        return;
      }
      this.$refs.qualifiedSignatureLoadingModal.text = this.$t(
        'modal.qualifiedSignatureCertificatePluginModal.loading.verifyPluginAuth'
      );
      if (!this.app) {
        await this.authorize();
        return;
      }
      try {
        await this.login();
      } catch (error) {
        this.app = '';
        await this.authorize();
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
        return;
      }
      this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
      await this.listCertificates();
    },
    async authorize() {
      try {
        const res = await SignPluginService.authorize();
        this.app = res.data;
        LocalStorage.set('signg-plugin-app-data', res.data);
        this.$refs.qualifiedSignaturePluginAuthorizeModal.link =
          this.app.AuthorizationUrl;

        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
        this.$refs.qualifiedSignaturePluginAuthorizeModal.$refs.modal.open();

        this.startLoginPolling();
      } catch (err) {
        this.canProceed = false;
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
        Logger.consoleError('Plugin authorization failed', err);
        alert.fireAlert(
          this.$t(
            'modal.qualifiedSignatureCertificatePluginModal.authorizationPluginError'
          ),
          {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
            icon: 'triangle-exclamation',
          }
        );
      }
    },
    async login() {
      try {
        const res = await SignPluginService.login(
          this.app.Id,
          this.app.Key,
          this.nonce,
          this.challenge,
          this.license
        );
        this.token = res.data.token;
      } catch (err) {
        this.token = '';
        Logger.consoleError('Plugin login failed, cannot get token', err);
        throw err;
      }
    },
    async authorizeModalClosed() {
      if (this.loginPollingInterval) {
        clearInterval(this.loginPollingInterval);
        this.loginPollingInterval = null;
      }
    },
    async listCertificates() {
      try {
        const res = await SignPluginService.listCertificates(this.token);
        this.certificates = res.data.CertificateList;
      } catch (error) {
        this.certificates = [];
        Logger.consoleError('Not found certificates, list is clear', error);
        alert.fireAlert(
          this.$t(
            'modal.qualifiedSignatureCertificatePluginModal.certificatesPluginError'
          ),
          {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
            icon: 'triangle-exclamation',
          }
        );
        throw error;
      }
      this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
      this.$refs.qualifiedSignatureListCertificatesPluginModal.$refs.modal.open();
    },
    async getEnvelopeFilesHashes(x509) {
      return await EnvelopesPublicService.getSignableHashes(
        this.$route.params.token,
        x509,
        this.location.latitude,
        this.location.longitude
      );
    },
    async onSelectCertificate(cert) {
      this.cert = cert;
      this.pin = '';
      this.pinErrorMsg = '';
      this.$refs.qualifiedSignatureListCertificatesPluginModal.$refs.modal.close();
      this.$refs.qualifiedSignatureLoadingModal.text = this.$t(
        'modal.qualifiedSignatureCertificatePluginModal.loading.verifyPluginSignature'
      );
      this.$refs.qualifiedSignatureLoadingModal.$refs.modal.open();
      if (this.cert.NeedsPIN) {
        this.canProceed = false;
        this.$refs.qualifiedSignaturePinPluginModal.$refs.modal.open();
        return;
      }
      try {
        this.canProceed = true;
        await this.signWithPluginFlow();
      } catch (err) {
        this.canProceed = false;
        Logger.consoleError('Sign plugin flow failed WITHOUT PIN:', err);
        this.$emit('error', err);
      }
    },
    async authCertificate() {
      this.$refs.qualifiedSignatureLoadingModal.text = this.$t(
        'modal.qualifiedSignatureCertificatePluginModal.loading.processPluginSignature'
      );
      this.$refs.qualifiedSignatureLoadingModal.$refs.modal.open();
      try {
        await SignPluginService.certificateAuth(
          this.token,
          this.cert.Id,
          this.pin
        );
      } catch (err) {
        Logger.consoleError('Auth certificate failed', err);
        throw err;
      } finally {
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
      }
    },
    async getAuthCertificate() {
      this.$refs.qualifiedSignatureLoadingModal.text = this.$t(
        'modal.qualifiedSignatureCertificatePluginModal.loading.processPluginSignature'
      );
      this.$refs.qualifiedSignatureLoadingModal.$refs.modal.open();
      try {
        const certRes = await SignPluginService.getCertificate(
          this.token,
          this.cert.Id
        );
        this.$emit('certificate', certRes.data.X509pem);
        return certRes;
      } catch (err) {
        Logger.consoleError('Get authenticated certificate failed', err);
        throw err;
      } finally {
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
      }
    },
    async signEnvelopeWithPlugin(certRes) {
      this.$refs.qualifiedSignatureLoadingModal.text = this.$t(
        'modal.qualifiedSignatureCertificatePluginModal.loading.processPluginSignature'
      );
      this.$refs.qualifiedSignatureLoadingModal.$refs.modal.open();
      try {
        const filesRes = await this.getEnvelopeFilesHashes(
          certRes.data.X509pem
        );
        this.documents = filesRes.data.documents;
        this.$emit('tcn', filesRes.data.tcn);
        const docs = [];
        for (let i = 0; i < this.documents.length; i++) {
          const document = this.documents[i];
          const res = await SignPluginService.sign(
            this.token,
            this.cert.Id,
            document.signable_hash
          );
          let signature = res.data.Signature.replace(
            '-----BEGIN PKCS1 SIGNATURE-----\n',
            ''
          );
          signature = signature.replace('\n-----END PKCS1 SIGNATURE-----', '');
          docs.push({
            id: document.id,
            signature,
          });
        }
        this.$emit('signed-hashes', docs);
      } catch (error) {
        Logger.consoleError('Falha ao assinar documento', error);
        try {
          await EnvelopesPublicService.resetProcessing(
            this.$route.params.token
          );
        } catch (resetError) {
          Logger.consoleError('Falha ao resetar o envelope', resetError);
        }
        this.canProceed = false;
        throw error;
      } finally {
        this.$refs.qualifiedSignatureLoadingModal.$refs.modal.close();
      }
    },
    async authenticateCertificate() {
      await this.authCertificate();
      return await this.getAuthCertificate();
    },
    async signWithPluginFlow() {
      const certRes = await this.authenticateCertificate();
      await this.signEnvelopeWithPlugin(certRes);
    },
    async pinModalConfirmed(pin) {
      this.pin = pin;
      this.pinErrorMsg = '';
      let certRes;
      try {
        certRes = await this.authenticateCertificate();
      } catch (err) {
        this.canProceed = false;
        this.pin = '';
        this.pinErrorMsg = this.$t(
          'modal.qualifiedSignatureCertificatePluginModal.needsPin.errorMsg'
        );
        Logger.consoleError(
          'Certificate authentication failed on pin confirmation',
          err
        );
        this.$loading(false);
        return;
      }

      try {
        await this.signEnvelopeWithPlugin(certRes);
        this.canProceed = true;
        this.$refs.qualifiedSignaturePinPluginModal.$refs.modal.close();
      } catch (err) {
        this.canProceed = false;
        this.pinErrorMsg = '';
        this.pin = '';
        Logger.consoleError(
          'Failed to sign with plugin after authentication with pin confirmation',
          err
        );
        this.$refs.qualifiedSignaturePinPluginModal.$refs.modal.close();
        this.$emit('error', err);
      } finally {
        this.$loading(false);
      }
    },
    startLoginPolling() {
      this.canProceed = false;

      if (this.loginPollingInterval) {
        clearInterval(this.loginPollingInterval);
      }

      this.loginPollingInterval = setInterval(async () => {
        try {
          await this.login();
          this.canProceed = true;
          clearInterval(this.loginPollingInterval);
          this.loginPollingInterval = null;
        } catch (err) {
          Logger.consoleError('Login attempt failed', err);
        }
      }, 2000);
    },
    async onProceed() {
      try {
        if (this.token) {
          await this.listCertificates();
        }
        this.$refs.qualifiedSignaturePluginAuthorizeModal.$refs.modal.close();
      } catch (err) {
        Logger.consoleError('Failed to proceed', err);
      }
    },
  },
};
</script>
